module.exports = __webpack_public_path__ + "img/2024-03-19a_1.45852e3e.jpg";